import { gql } from 'apollo-angular';

// Status do 2FA do usuário logado (usado na página /user)
const MFA_STATUS_QUERY = gql`
  query MfaStatus($username: String) {
    user(username: $username) {
      edges {
        node {
          id
          username
          mfaEnabled
        }
      }
    }
  }
`;

// Inicia o cadastro: o Bifrost gera um segredo novo e devolve o QR code (PNG em data URI)
const MFA_SETUP_START = gql`
  mutation MfaSetupStart {
    mfaSetupStart(input: {}) {
      qrCode
    }
  }
`;

// Confirma o cadastro com o primeiro código do app e devolve os 10 códigos de recuperação
const MFA_SETUP_CONFIRM = gql`
  mutation MfaSetupConfirm($code: String!) {
    mfaSetupConfirm(input: { code: $code }) {
      recoveryCodes
    }
  }
`;

// Gera 10 códigos novos (os antigos deixam de valer)
const MFA_RECOVERY_CODES_REGENERATE = gql`
  mutation MfaRecoveryCodesRegenerate($code: String!) {
    mfaRecoveryCodesRegenerate(input: { code: $code }) {
      recoveryCodes
    }
  }
`;

// Desativa o 2FA: exige a senha e um código do app
const MFA_DISABLE = gql`
  mutation MfaDisable($password: String!, $code: String!) {
    mfaDisable(input: { password: $password, code: $code }) {
      user {
        id
        mfaEnabled
      }
    }
  }
`;

const USER_MFA_RESET = gql`
  mutation MfaReset($userId: ID!, $company: ID!) {
    userMfaReset(input: { userId: $userId, company: $company }) {
      user {
        id
        mfaEnabled
      }
    }
  }
`;

export {
  MFA_STATUS_QUERY,
  MFA_SETUP_START,
  MFA_SETUP_CONFIRM,
  MFA_RECOVERY_CODES_REGENERATE,
  MFA_DISABLE,
  USER_MFA_RESET
};
